import type { ReactNode } from 'react';
import { StatusIcon } from './StatusIcon';
import styles from './Notice.module.css';

export type NoticeTone = 'danger' | 'warning';

interface Props {
  /** danger = blocks the action (red); warning = needs attention, not blocking (amber). */
  tone: NoticeTone;
  children: ReactNode;
  testId?: string;
}

const ICON = { danger: 'close', warning: 'hourglass' } as const;
const TONE_CLASS = { danger: styles.toneDanger, warning: styles.toneWarning } as const;

/**
 * Inline notice next to an action: icon + colour + words (UX principle 3), status tokens only.
 * Shared so a blocker or an alert looks the same on every screen.
 */
export function Notice({ tone, children, testId }: Props) {
  return (
    <div
      className={`${styles.notice} ${TONE_CLASS[tone]}`}
      data-tone={tone}
      data-testid={testId}
    >
      <span className={styles.icon} aria-hidden="true">
        <StatusIcon name={ICON[tone]} size={14} />
      </span>
      <span className={styles.body}>{children}</span>
    </div>
  );
}
